import styled from '@emotion/styled';
import { primaryFontFamily } from '../../styles/fonts';
import { boxShadow } from '../../styles/mixins';
import { minDeviceWidth } from '../../styles/responsive';

export type WrapperProps = {
  hasElevation?: boolean;
  disableBorderAndShadows?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  border: ${({ theme, hasElevation, disableBorderAndShadows }) => {
    if (disableBorderAndShadows) {
      return '0';
    }

    if (!hasElevation) {
      return `1px solid ${theme.default.colors.n2}`;
    }

    return `0`;
  }};
  border-radius: 4px;
  background: ${({ theme }) => theme.default.colors.n0};
  box-sizing: border-box;

  ${primaryFontFamily}

  @media ${minDeviceWidth('tablet')} {
    border: ${({ theme, hasElevation, disableBorderAndShadows }) => {
      if (disableBorderAndShadows) {
        return '0';
      }

      if (!hasElevation) {
        return `1px solid ${theme.default.colors.n2}`;
      }
      return `0`;
    }};

    ${({ hasElevation, disableBorderAndShadows }) => {
      if (disableBorderAndShadows) {
        return `box-shadow: none`;
      }

      if (hasElevation) {
        return boxShadow;
      }

      return `box-shadow: none`;
    }};
  }
`;

export type HeaderProps = {
  isDashed?: boolean;
};

export const Header = styled.div<HeaderProps>`
  padding: 24px;
  border-width: 0 0 1px 0;
  border-style: ${({ isDashed = false }) => (isDashed ? 'dashed' : 'solid')};
  border-color: ${({ theme }) => theme.default.colors.n2};

  color: ${({ theme }) => theme.default.colors.n5};

  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 26px;

  @media ${minDeviceWidth('tablet')} {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const Content = styled.div`
  padding: 24px;
`;

const Paper = { Wrapper, Header, Content };

export default Paper;
